import { idSchema } from '@/lib/utils'
import { z } from 'zod/v4'

export const productParamsSchema = z.object({
  productId: idSchema('product'),
})

// Backward-compatible export while callers migrate to the params-specific name.
export const productSchema = productParamsSchema
